import { DateTime } from "luxon"
import { useEffect, useState } from "react"

export const useServiceStatus = (directTunnelServiceStatus) => {

	const [serviceStatus, setServiceStatus] = useState({
		connected: null,
		lastSeen: null
	})

	const handleServiceStatus = () => {
		directTunnelServiceStatus.data?.connected
			? setServiceStatus({ connected: "Connected", lastSeen: null })
			: setServiceStatus({ connected: "Disconnected", lastSeen: DateTime.fromISO(directTunnelServiceStatus.data?.last_seen).toHTTP() })
	}

	useEffect(() => {
		directTunnelServiceStatus?.data && handleServiceStatus()
	}, [directTunnelServiceStatus])

	return { serviceStatus }
}
